import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import hero from "../../assets/gems-jewellery.jpg";

// Gallery Images
import gem1 from "../../assets/gem1.jpg";
import gem2 from "../../assets/gem2.jpg";
import gem3 from "../../assets/gem3.jpg";

function GemsAndJewellery() {
    const [activeImage, setActiveImage] = useState(gem1);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${hero})` }}
                />
                <div className="absolute inset-0 bg-black/70" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Gems & Jewellery
                    </h1>

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        Discover the Brilliance of Sri Lanka’s World-Famous Gems
                    </p>
                </div>
            </section>

            {/* ================= GEMS & JEWELLERY SECTION ================= */}
            <section className="bg-white py-16 px-4 sm:px-8 lg:px-20">
                <div className="max-w-7xl mx-auto">

                    {/* Title */}
                    <h2
                        data-aos="fade-up"
                        className="text-center text-2xl sm:text-3xl md:text-4xl font-semibold text-blue-900 tracking-wide"
                    >
                        Authentic Ceylon Gems & Handcrafted Jewellery
                    </h2>

                    {/* Content */}
                    <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                        {/* Text Content */}
                        <div data-aos="fade-right" className="space-y-5 text-gray-700 text-sm sm:text-base leading-relaxed">

                            <p>
                                Sri Lanka is known as the "Island of Gems" and produces some of the world’s finest sapphires,
                                rubies, cat’s eyes and semi-precious stones. Our Gems & Jewellery experience connects you
                                directly with trusted gem merchants and certified dealers.
                            </p>

                            <p>
                                Explore gem museums, cutting and polishing workshops, and exclusive showrooms where you can
                                see how raw stones are transformed into dazzling masterpieces.
                            </p>

                            <p>
                                Whether you are looking for loose gemstones, engagement rings, luxury jewellery or
                                custom-made designs, we ensure quality, authenticity and transparent pricing.
                            </p>

                            <p>
                                All gems are supplied with certification and export documentation, allowing you to purchase
                                with complete confidence.
                            </p>

                        </div>

                        {/* Image Section */}
                        <div data-aos="fade-left" className="relative">

                            {/* Main Image */}
                            <img
                                src={activeImage}
                                alt="Sri Lanka Gems & Jewellery"
                                className="rounded-lg shadow-xl w-full h-[350px] object-cover transition duration-300"
                            />

                            {/* Thumbnail Strip */}
                            <div className="flex gap-3 mt-4 justify-center">
                                {[gem1, gem2, gem3].map((img, index) => (
                                    <img
                                        key={index}
                                        src={img}
                                        onClick={() => setActiveImage(img)}
                                        className={`w-20 h-14 object-cover rounded-md shadow cursor-pointer transition
                                        ${activeImage === img
                                                ? "ring-2 ring-blue-600 scale-105"
                                                : "opacity-70 hover:opacity-100"
                                            }`}
                                        alt="thumbnail"
                                    />
                                ))}
                            </div>

                        </div>

                    </div>
                </div>
            </section>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94743412910"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default GemsAndJewellery;
